import { render, staticRenderFns } from "./BulkForm.vue?vue&type=template&id=2ea8c0ae&scoped=true&"
import script from "./BulkForm.vue?vue&type=script&lang=js&"
export * from "./BulkForm.vue?vue&type=script&lang=js&"
import style0 from "./BulkForm.vue?vue&type=style&index=0&id=2ea8c0ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea8c0ae",
  null
  
)

export default component.exports